import { Injectable, signal, Signal } from "@angular/core";
import GeobusNavigationExtension from "./geobus-navigation.extension";
import { IType } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })
export default class GeobusModelExtension extends GeobusNavigationExtension {

    public get component(): IType<unknown> | null {
        return null;
    }

    public get identifier(): string | null {
        return "GeobusModelExtensionName";
    }

    public get title(): Signal<string> {
        return signal("SIDE_MENU.DATA.MODELS").asReadonly();
    }

    public get category(): string {
        return "data";
    }

    public get state(): { name: string } {
        return { name: "app.models" };
    }

    public get icon(): string {
        return "table";
    }

}
